module.exports = __webpack_public_path__ + "static/media/Group109.020b60ab.png";